"use client";

import type { PortalTenant } from "@/lib/tenant/helpers";
import React from "react";

const TenantContext = React.createContext<PortalTenant | null>(null);

export function TenantProvider({ children, tenant }: { children: React.ReactNode; tenant: PortalTenant }) {
  return <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>;
}

export function useTenant() {
  const tenant = React.useContext(TenantContext);

  if (!tenant) {
    throw new Error("No tenant configured");
  }

  return tenant;
}

export function useTenantId() {
  return useTenant().firebaseTenantId;
}
